import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import {computed, ref, watch} from 'vue'

  import LazyImage from '@/components/LazyImage'

  import {useSizable} from '@/lib/sizable'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsiveImage',
  props: {
    /*
     * Array of objects describing available image versions.
     *
     * Example:
     *
     * [
     *   {
     *     width_px: 100,
     *     url: 'path/to/imahe'
     *   },
     *
     *   ...
     * ]
     */
    imageVersions: {
      type: Array,
      required: true
    },

    alt: {
      type: String,
      required: true
    }
  },
  setup(__props) {

const props = __props;

  const DEFAULT_DPI = 1
  const DEFAULT_WIDTH = 0

  function getPixilRatio() {
    return window.devicePixelRatio || DEFAULT_DPI
  }

  const root = ref()

  const {width} = useSizable(root)

  

  const maxWidthValue = ref(DEFAULT_WIDTH)
  const pixilRatio = getPixilRatio()

  // The largest width that image element has had
  const maxWidth = computed({
    get() {
      return maxWidthValue.value
    },

    // Set max width, considering pixil ratio
    set(value) {
      maxWidthValue.value = Math.max(maxWidthValue.value, value * pixilRatio)
    }
  })

  // Order `this.imageVersions` by `width_px` asc
  const sortedVersions = computed(() => {
    return props.imageVersions.slice().sort((a, b) => {
      return a.width_px - b.width_px
    })
  })

  // The current image version
  const imageVersion = computed(() => {
    return (
      sortedVersions.value.find((version) => {
        return version.width_px >= maxWidthValue.value
      }) || fallbackVersion.value
    )
  })

  // Fall back to largest image version
  const fallbackVersion = computed(() => {
    const versions = sortedVersions.value

    return versions.length ? versions[versions.length - 1] : {}
  })

  // Current image url
  const src = computed(() => {
    return imageVersion.value.url || null
  })

  watch(width, (value) => {
    maxWidth.value = value
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "responsive-image"
  }, [
    (_unref(src))
      ? (_openBlock(), _createBlock(_unref(LazyImage), {
          key: 0,
          alt: __props.alt,
          src: _unref(src)
        }, null, 8, ["alt", "src"]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})